import PropTypes from 'prop-types';

export const GenresModel = {
  id: PropTypes.string,
  genreName: PropTypes.string
};

export default GenresModel;
